/* eslint-disable react-hooks/exhaustive-deps */
import { Button, DatePicker, Flex, Form, Select } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import SelectDropdownLgIcon from "../../../../assets/icons/SelectDropdownLgIcon";
import CustomDrawer from "../../../../components/ui/CustomDrawer";
import { useAssignShiftMutation } from "../../../../features/organization/contractual/JobDetails/jobDetailsApi";
import { useGetAllShiftQuery } from "../../../../features/organization/contractual/ShiftManagement/shiftManagementApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";
import { selectArrayOption, selectSearchOption } from "../../../../utils/utils";
import CalanderIcon from "../../survey/templates/_icons/CalanderIcon";

export default function ManageAssignShift({
  type,
  open,
  handleClose,
}: {
  type?: string;
  open: boolean;
  handleClose: (value?: boolean) => void;
}) {
  const [form] = Form.useForm();
  const { id, memberId } = useParams();
  const watchedShiftId = Form.useWatch("shift_id", form);

  const { data: allShift } = useGetAllShiftQuery({
    params: { limit: 100000, skip: 0, status: "active" },
  });
  const selectedShift = allShift?.data?.shifts?.find(
    (s) => s?.id === watchedShiftId
  );
  const fromDate = dayjs(selectedShift?.from_date);
  const toDate = dayjs(selectedShift?.to_date);

  const [assignShift, { isLoading, isSuccess, isError, error }] =
    useAssignShiftMutation();

  const handleSubmit = (values: any) => {
    assignShift({
      ...values,
      job_apply_id: id,
      member_id: memberId,
      effective_date: dayjs(values?.effective_date).format("YYYY-MM-DD"),
    });
  };

  const disableOutOfRangeDates = (current: dayjs.Dayjs) => {
    if (!current || !watchedShiftId) return false;
    return current.isBefore(fromDate, "day") || current.isAfter(toDate, "day");
  };

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Another shift assigned successfully");
      handleClose();
      form.resetFields();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (fromDate && watchedShiftId) {
      // form.setFieldValue("effective_date", fromDate);
    }
  }, [fromDate, watchedShiftId]);

  useError(isError, error, "Another shift assign failed.");
  return (
    <>
      <CustomDrawer
        width={460}
        open={open}
        onClose={() => {
          handleClose();
          form.resetFields();
        }}
        title={"Assign Another Shift"}
      >
        <Form
          form={form}
          size="large"
          layout="vertical"
          requiredMark="optional"
          className="custom-form"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="shift_id"
            label="Select Shift"
            className="mb-4"
            rules={[{ required: true, message: "Please enter select shift" }]}
          >
            <Select
              placeholder="Select Shift"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              suffixIcon={<SelectDropdownLgIcon />}
              options={selectArrayOption(
                allShift?.data.shifts || [],
                "shift_name",
                "id"
              )}
            />
          </Form.Item>

          <Form.Item
            name="effective_date"
            label="Effective Date"
            className="mb-4"
            rules={[
              { required: true, message: "Please select effective date" },
            ]}
          >
            <DatePicker
              className="w-full"
              format={"DD-MM-YYYY"}
              placeholder={"Select a date"}
              suffixIcon={<CalanderIcon />}
              disabledDate={disableOutOfRangeDates}
            />
          </Form.Item>

          <Flex align="center" gap={16} className="mt-6">
            <Button
              size="middle"
              htmlType="button"
              className="min-w-[120px] h-10"
              onClick={() => handleClose()}
            >
              Cancel
            </Button>
            <Button
              size="middle"
              htmlType="submit"
              type="primary"
              color="primary"
              loading={isLoading}
              className="min-w-[120px] h-10"
            >
              Assign Shift
            </Button>
          </Flex>
        </Form>
      </CustomDrawer>
    </>
  );
}
